import React, { useContext, useEffect, useState, useRef } from "react";
import { isEmpty, isUndefined } from "lodash";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import "../../../styles/components/CommunicationCard.scss";
import { Formik, Field } from "formik";
import {
  ManageCommunicationLayout,
  FieldInput,
  EmailLayout,
  FormControlSearch,
  LoaderWrapper,
} from "../../../components";
import { Link } from "react-router-dom";
import {
  manageCommunicationFormNames,
  formFields,
  MANAGE_COMMUNICATION_ROUTES,
  FLOW_TYPES,
  getPathWithParam,
} from "../../../utils";
import {
  manageCommunicationStore,
  setCommunicationLocalCache,
} from "../../../contexts";
import InfiniteScroll from "react-infinite-scroller";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import { getEmailLayout } from "../../../services";
const initialValues = {};

const EmailLayoutContainer = (props) => {
  const { history } = props;
  const [toggle, setToggle] = useState(false);
  const { state, dispatch } = useContext(manageCommunicationStore);
  const formName = manageCommunicationFormNames.PLAN_LEVEL_COMMUNICATION;
  const fields = formFields[formName];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const searchString = useRef(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const append = useRef(false);
  const numberOfRecordsToFetch = 20;
  const [request, setRequest] = useState({
    from: 0,
    offset: numberOfRecordsToFetch,
  });
  const buttons = [
    {
      link: getPathWithParam({
        path: MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO,
        pathParam: [FLOW_TYPES.ADD],
      }),
      label: "New E-Mail Layout",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
    },
  ];
  const formValues = {};
  useDeepEffect(() => {
    setLoading(true);
    getEmailLayout({
      search: "",
      ...request,
    }).then((response) => {
      setLoading(false);
      if (response?.length < numberOfRecordsToFetch)
        setStopInfiniteScroll(true);
      if (append.current)
        setData((prev) => {
          return [...prev, ...response];
        });
      else setData(response);
      dispatch(
        setCommunicationLocalCache({
          model: "allEmailLayouts",
          data: response,
        })
      );
    });
  }, [request]);
  const onFormSubmit = (values) => {
    if (isUndefined(values.search) || values.search === "") values.search = "";
    searchString.current = values.search === "" ? false : true;
    setStopInfiniteScroll(false);
    append.current = false;
    setRequest({
      from: 0,
      offset: numberOfRecordsToFetch,
      search: values.search,
    });
  };
  return (
    <ManageCommunicationLayout
      pageName="E-Mail Layout"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
      overflow="overflow-hidden"
    >
      <Formik
        initialValues={{
          ...initialValues,
        }}
        onSubmit={onFormSubmit}
        enableReinitialize
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          return (
            <LoaderWrapper isLoading={loading} className="noScrollBar">
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
                validated={!isEmpty(rest.errors)}
              >
                <div className="EmailLayoutContainer">
                  <div className="header1">
                    {/* <div className="ft-14 lh-19 mb-6 ftwt-500">
                        Search Layout
                      </div> */}
                    {/* <Form> */}
                    <div style={{ width: "100%" }}>
                      <InputGroup>
                        <InputGroup.Prepend>
                          <InputGroup.Text className="plan-search-button">
                            <Image
                              src="/assets/icons/svg/search.svg"
                              width="14px"
                            />
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControlSearch
                          size="xxxl"
                          type="search"
                          label="Search"
                          placeholder="Search by layout name"
                          onChange={(e) => {
                            setFieldValue(fields.search, e.target.value);
                          }}
                        />
                      </InputGroup>
                    </div>
                    {/* </Form> */}
                    <div>
                      <Button type="submit" variant="secondary">
                        Search
                      </Button>
                    </div>
                  </div>
                  {data.length !== 0 ? (
                    <div
                      className="header2"
                      style={{
                        color: "black",
                        fontSize: "14px",
                        fontWeight: "normal",
                      }}
                    >
                      <p>Recently added/Modified</p>
                      <p style={{ marginRight: "15px" }}>
                        {data.length} E-Mail Layouts found
                      </p>
                    </div>
                  ) : null}
                  <div style={{ height: "70%", overflow: "scroll" }}>
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={() => {
                        append.current = true;
                        setRequest((prevRequest) => ({
                          ...prevRequest,
                          from: data?.length,
                        }));
                      }}
                      hasMore={!stopInfiniteScroll}
                      initialLoad={false}
                      //threshold={100}
                      useWindow={false}
                      loader={
                        <div className="loader" key={0}>
                          Loading ...
                        </div>
                      }
                    >
                      <div className="bodyContent overflow-visible">
                        {!searchString.current ? (
                          <Link
                            to={getPathWithParam({
                              path: `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO}`,
                              pathParam: [FLOW_TYPES.ADD],
                            })}
                          >
                            <EmailLayout isNewLayout />
                          </Link>
                        ) : null}
                        {data.length === 0 ? (
                          <span
                            style={{
                              margin: "auto",
                              textAlign: "center",
                              fontSize: "18px",
                              color: "#333333",
                            }}
                          >
                            No Records Found
                          </span>
                        ) : (
                          data.map((x) => {
                            return (
                              <Link
                                to={getPathWithParam({
                                  path: `${MANAGE_COMMUNICATION_ROUTES.EMAIL_LAYOUT_INFO}`,
                                  pathParam: [FLOW_TYPES.EDIT, x.id],
                                })}
                              >
                                <EmailLayout
                                  thumbNail={x.imagePath}
                                  data={x.layoutName}
                                />
                              </Link>
                            );
                          })
                        )}
                      </div>
                    </InfiniteScroll>
                  </div>
                </div>
              </Form>
            </LoaderWrapper>
          );
        }}
      </Formik>
    </ManageCommunicationLayout>
  );
};

export default EmailLayoutContainer;
